<template>
    <li v-if="ready" class="nav-item dropdown-user">
        <a href="javascript:void(0)" class="" v-on:click="logout"><i class="icon-switch2"></i> Logout</a>
    </li>

</template>
<script>

export default {
    name: 'user',

    components : {

    },
    watch: {
        loggedUser : function (newValue, oldValue) {
            this.ready = (newValue !== null )
        }
    },
    data () {
        return {
            ready : false
        }
    },
    computed: {
        userFullName(){
            return (this.loggedUser !== null ) ? this.loggedUser.first_name + ' '  + this.loggedUser.first_name : ''
        }
    },
    mounted(){
        this.ready = (this.loggedUser !== null )
    },
    destroyed(){

    },
    methods : {
        logout : function(){
            this.$store.dispatch('pnotify/alert', {
                title: `See you soon, ${this.loggedUser.name}.`,
                //text: 'Enjoy life!',
                addclass: 'bg-primary border-primary'
            }, {root:true});
            this.$store.dispatch('auth/logout');
            this.$router.push('/auth/login');
        }
    }


}
</script>